export class AppMessages {
  static SAVE_LC_USER_INFOR_SUCCESS = "Thông tin của của bạn đã được cập nhật";
  static SAVE_LC_USER_INFOR_ERROR = "Vui lòng nhập lại thông tin";
  static DEFAULT_SIGNIN_ERROR =
    "Số điện thoại của bạn chưa đăng ký. Vui lòng đăng ký";
  static OTP_ERROR =
    "Không thể gửi OTP đến số điện thoại này. Vui lòng kiểm tra lại hoặc liên hệ với quản trị";
  static INVALID_RESEND_TIME =
    "Yêu cầu gửi mã OTP của bạn đang được chúng tôi xử lý, bạn hãy thử lại sau 1 phút nhé";
  static INVALID_OTP_CODE = "OTP không hợp lệ hoặc đã hết hiệu lực";
  static PHONE_EXITS = "Số điện thoại của bạn <br/> đã được đăng ký";
  static PHONE_NOT_EXITS =
    "Số điện thoại của bạn chưa được đăng ký. <br/> Vui lòng cung cấp thông tin ở Landing Page và quay lại nhận quà nhé!";
  static DEFAULT_SIGNUP_ERROR =
    "Số điện thoại này đã tồn tại. Vui lòng đăng nhập";
  static INVALID_FORM_EMPTY = "Vui lòng nhập thông tin";
  static INVALID_GIFT_QUANTITY = "Kho quà đã hết";
  static OUT_OFF_SERVICE_TIME = "Đã hết thời gian tham gia đổi quà";
  static INVALID_GIFT_TURN = "Số hộp quà đã hết";
  static NOT_ACCESS_CAMERA = "Không thể truy cập camera";
  static INVALID_GIFT_OVER_QUANTITY =
    "Số quà đã nhận vượt quá số lượng quà trong ngày";
  static PHONE_IS_BLANK = "Vui lòng nhập số điện thoại";
  static VOUCHER_ERROR = "Không thể cấp phát voucher";
  static INVOICE_GIFT_ERROR = "Hóa đơn này đã được nhận quà";
  static EMPTY_MALL_OR_STORE = "Vui lòng chọn hệ thống cửa hàng/siêu thị/chợ";
  static EMPTY_STORE_CODE = "Vui lòng nhập mã cửa hàng";
  // validation
  static INVALID_INPUT_SIGNUP_EMAIL_ERROR = "Email không hợp lệ";
  static INVALID_INPUT_SIGNUP_NAME_ERROR = "Họ và Tên không hợp lệ";
  static INVALID_INPUT_SIGNUP_PHONE_ERROR = "Số điện thoại không hợp lệ";
  static INVALID_INPUT_SIGNUP_BIRTHDAY_ERROR = "Ngày sinh không hợp lệ";
  static INVALID_INPUT_SIGNUP_RULES =
    "Vui lòng đồng ý các điều khoản của chương trình!";
  static INVALID_FILE = "Định dạng tập tin không được hỗ trợ";
  static INVALID_FILE_SIZE = "Kích thước tập tin quá lớn";
  static INVALID_SHOP_TYPE = "Vui lòng chọn shop type";
  static INVALID_SHOP_NAME = "Vui lòng nhập shop name";
  static INVALID_PROVINCE = "Vui lòng chọn Tỉnh/Thành phố";
  static INVALID_SKIN_CARE =
    'Điền thêm thông tin "Nhu cầu chăm sóc da quan tâm" để tham gia chương trình';
  static INVALID_LOCATION = "Vui lòng chọn địa điểm";
  static INVALID_GENDER = "Vui lòng chọn giới tính";
  static GIFT_STORE_IS_EMPTY = "Kho quà đã hết";
  static INVALID_QUANTITY = "Vui lòng nhập số lượng";
  static SEND_OTP_FAIL = "Gửi mã xác thực thất bại";

  // OCR message
  static BILLID_IS_EMPTY = "Mã hóa đơn không được rỗng";
  static BILL_DATE_EMPTY = "Ngày trên hóa đơn không được rỗng";
  static MALL_EMPTY = "Chuỗi siêu thị/cửa hàng không được rỗng";
  static STORE_EMPTY = "Tên siêu thị không được rỗng";
  static OUT_OF_DATE_ERROR =
    "Ngày trên hóa đơn không nằm trong ngày áp dụng của chương trình";
  static USED_BILL_ERROR = "Hóa đơn đã đổi quà, vui lòng kiểm tra lại ";
  static INVALID_PRICE =
    "Giá trị hóa đơn không đủ điều kiện để nhận quà, vui lòng kiểm tra lại";
  static OUT_OF_STORE = "Cửa hàng/siêu thị không nằm trong chương trình";
  static REPRINT = "Hóa đơn in lại";
  static BILL_EXIST = "Hóa đơn đã tồn tại";
  static TWO_INVOICE =
    "Hệ thống không hỗ trợ </br> nhiều hóa đơn khác nhau, </br> vui lòng kiểm tra lại";
  static REPRINT_INVOICE =
    "Hóa đơn in lại </br> không thể tham gia chương trình";
  static INCCORECT_IMAGE_SEQUENCE = "Hình chụp không đúng thứ tự";
  static REVERSE_BILL = "Vui lòng để hóa đơn ngay ngắn</br> và thử lại";
  static MAXANGLE_BILL = "Vui lòng để hóa đơn ngay ngắn </br>và chụp lại nhé";
  static EXCEPTION_BILL = "Mẫu hóa đơn không được hỗ trợ";

  // Mechanic
  static INVALID_INVOICE = "Hóa đơn không đủ điều kiện tham gia chương trình";
  static INVALID_INPUT =
    "Thông tin nhập vào không hợp lệ, vui lòng kiểm tra lại";

  // Browser error
  static ZALO_BROWSER_ERROR =
    "Bạn đang sử dụng trình duyệt của <b>ZALO</b>.</br>Trình duyệt này không sử dụng được camera";
  static FB_BROWSER_ERROR =
    "Bạn đang sử dụng trình duyệt của <b>FACEBOOK</b>.</br>Trình duyệt này không sử dụng được camera";
  static NO_CAMPAIGN_ACTIVE =
    "Tài khoản này <br> không có chương trình nào <br> đang hoạt động <br> Vui lòng liên hệ <br> với người phụ trách";
  static NOCAMPAIGN_SESSIONEXPIRE =
    "Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại";
  static INVALID_USERNAME_OR_PASS = "Tên đăng nhập hoặc <br> mật khẩu bị sai";
  static INVALID_CAMPAIGN =
    "Không tìm thấy chương trình <br> tại thời điểm hiện tại.";

  //QR Code
  static INVALID_DATA = "Mã code của bạn không hợp lệ. Vui lòng kiểm tra lại";
  static CODE_USED = "Code này đã được sử dụng";
  static CODE_EXPIRED = "Code đã hết hạn";
  static CAMPAIGN_MAX_GIFT =
    "Bạn đã tham gia chương trình. 1 số điện thoại hoặc 1 điện thoại chỉ tham gia chương trình 1 lần";

  //Stock
  static STOCK_REQUEST_EMPTY = "Yêu cầu không hợp lệ";
  static STOCK_NO_STORE_PERMIT =
    "Không thể cập nhật quà của store mà mình không có quyền";
  static STOCK_CONFLICT =
    "Dữ liệu bị thay đổi bởi người khác, vui lòng làm mới trình duyệt và thử lại";
  static STOCK_ERROR = "Có lỗi xảy ra, không thể thực hiện cập nhật";

  //Gift
  static NOTE_SPECIAL_PRIZE =
    'Lưu ý: "1 chỉ vàng PNJ từ quà tặng GotIt,<br> tương đương 1 chỉ vàng PNJ 18K hoặc trang sức vàng, <br>không áp dụng vàng 24K và kim cương vỉ"';

  //Mechanic
  static MECHANIC_EMPTY = "Vui lòng chọn mechanic";

  //Telco
  static INVALID_TELCO_ERROR = "Vui lòng chọn nhà mạng";

  //Survey
  static INSERT_SURVEY_ERROR = "Lưu thông tin khỏa sát thất bại";
  static INVALID_SURVEY = "Vui lòng chọn hoặc nhập đầy đủ thông tin khảo sát";
  static THANKS_SURVEY =
    "Cảm ơn bạn đã tham gia khảo sát, thông tin của bạn sẽ góp phần giúp chúng tôi phục vụ bạn tốt hơn";

  //Emart skip PII
  static INVALID_POSID_ERROR = "POS ID không hợp lệ";
  static INVALID_EMPTY_POSID_ERROR = "Vui lòng nhập POS ID";
  static EMPTY_TICKET_DATE_ERROR = "Vui lòng chọn ngày xuất phiếu tặng quà";
  static EMPTY_TICKET_NOTE_ERROR =
    "Vui lòng nhập lý do chỉnh sửa phiếu tặng quà";
  static INVALID_TICKET_DATE_ERROR =
    "Ngày xuất phiếu tặng quà phải nhỏ hơn hoặc bằng ngày giờ hiện tại";
  static OUT_OF_CAMPAIGN_TICKET_DATE =
    "Ngày xuất phiếu tặng quà/hoá đơn phải nằm trong khung thời gian của chương trình";
  static POSID_EXITS = "POS ID đã được đăng ký nhận quà";
  static INVALID_TICKET_ERROR = "Phiếu quà tặng không hợp lệ";
  static TWO_TICKET_ERROR =
    "Hệ thống không hỗ trợ </br> nhiều phiếu quà tặng khác nhau, </br> vui lòng kiểm tra lại";
  static REVERSE_TICKET =
    "Vui lòng để phiếu quà tặng ngay ngắn</br> và thử lại";
  static MAXANGLE_TICKET =
    "Vui lòng để phiếu quà tặng ngay ngắn </br>và chụp lại nhé";
  static EXCEPTION_TICKET = "Mẫu không được hỗ trợ";

  // PONDS Uni Tour
  static PONDS_NO_ANSWER =
    "Người dùng này chưa điền thông tin 'Nhu cầu dưỡng da'. Vui lòng cung cấp thông tin ở Landing Page và quay lại nhận quà nhé!";

  //DETECT DEVICE
  static BROWSER_OUT_OF_SUPPORT = "Vui lòng sử dụng trình duyệt";
  static TO_CONTINUE = "để tiếp tục";
  static DEVICE_HAS_BLOCKED_1 = "Thiết bị của bạn đang tạm khóa";
  static DEVICE_HAS_BLOCKED_2 = "ngày do sử dụng quá";
  static DEVICE_HAS_BLOCKED_3 = "số điện thoại khác nhau để đăng nhập";
  static DEVICE_HAS_BLOCKED =
    "Hệ thống phát hiện giao dịch đổi quà bất thường tại thiết bị của bạn. Vui lòng tham gia đúng thể lệ chương trình.";
  static OPEN = "Mở";
  static CLOSE = "Đóng";
  static SOMETHING_WENT_WRONG = "Đã có lỗi xảy ra, xin vui lòng thử lại";
}
